import { useState } from 'react';
import { useParams } from 'react-router-dom';

import TestResults from '../components/Features/TestResults';
import { RootState } from '../redux/store';
import { useAppSelector } from '../redux/store/hooks';
import { useGetDriveResultQuery } from '../services/startTestAPI/startTestApi';

import HRInterviewResults from './HRInterviewResults';
import InterviewResults from './InterviewResults';

const DriveTestResult = () => {
  const { id, userId } = useParams();
  const [currentTab, setCurrentTab] = useState('Written');
  const { data, isLoading, isError } = useGetDriveResultQuery(
    {
      userTestId: id,
      userId: userId ?? ''
    },
    { refetchOnMountOrArgChange: true }
  );
  const { resultById } = useAppSelector(
    (state: RootState) => state.root.startFulltest
  );

  const tabs = [
    { id: 'Written', label: 'Written Test' },
    { id: 'Interview', label: 'Tech Interview' },
    { id: 'HR', label: 'HR Interview' }
  ];

  const renderContent = () => {
    switch (currentTab) {
      case 'Written':
        return <TestResults />;
      case 'Interview':
        return (
          <InterviewResults propsInterviewResults={resultById?.interviewTest} />
        );
      case 'HR':
        return (
          <HRInterviewResults propsInterviewResults={resultById?.hrTest} />
        );
      default:
        return null;
    }
  };

  if (isLoading) {
    return (
      <div className='flex min-h-screen items-center justify-center'>
        <div className='text-center'>
          <div className='mx-auto mb-4 h-16 w-16 animate-spin rounded-full border-4 border-primary border-t-transparent'></div>
          <p className='text-gray-600'>Loading results...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className='flex min-h-screen items-center justify-center'>
        <div className='max-w-md rounded-lg border border-red-200 bg-red-50 p-6'>
          <h3 className='mb-2 font-semibold text-red-800'>
            Error Loading Results
          </h3>
          <p className='text-red-600'>
            Unable to fetch test results. Please try again later.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen bg-gray-50 p-6'>
      <div className=''>
        <div className='mb-6 rounded-lg border border-gray-200 bg-white shadow-sm'>
          <div className='flex border-b border-gray-200'>
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setCurrentTab(tab.id)}
                className={`
                  flex-1 px-6 py-4 text-sm font-medium transition-all duration-200
                  ${
                    currentTab === tab.id
                      ? 'border-b-2 border-primary bg-blue-50 text-primary'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className='rounded-lg border border-gray-200 bg-white p-6 shadow-sm'>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default DriveTestResult;
